import React, { useMemo } from "react";
import { Rect } from "react-konva";
import useSeatmapStore from "../../../../../../../../../stores/seatmapStore";
import { useTooltips } from "../../../providers/TooltipProvider";

let globalHoverTimeout = null;
const TOOLTIP_TIMEOUT = 500;

const Seat = ({ seat }) => {
  const { showTooltip, hideTooltip } = useTooltips();
  const seatInfo = useSeatmapStore(state => state.seatLookupTable[seat.seatId]);
  const selectSpecificSeat = useSeatmapStore(state => state.selectSpecificSeat);
  const unselectSeat = useSeatmapStore(state => state.unselectSeat);
  const seatBorderRadius = useSeatmapStore(state => state.seatBorderRadius);

  // Could do this only once when creating lookupTable
  const seatColor = useMemo(() => {
    if (!seatInfo) return "#E6E8EC";
    if (seat.selected) return "rgba(20, 20, 22, 1)";
    if (seatInfo?.accessible) return "#FFA500";
    if (
        seatInfo?.offer &&
        seatInfo?.offer.accessCode &&
      !seatInfo?.offer?.unlocked
    )
      return "#353945";
    return seatInfo.resale
      ? "#E06C35"
      : seatInfo?.offer?.inventoryType === "exclusive"
      ? "#9757D7"
      : "#3E8BF7";
  }, [seat.selected, seatInfo]);

  const handleClick = () => {
    clearTimeout(globalHoverTimeout);
    hideTooltip();

    if (seat.selected) {
        clearTimeout(globalHoverTimeout);
        unselectSeat(seat.seatId, seatInfo);
    } else {
        selectSpecificSeat(seat.seatId, seatInfo);
    }
  };

  const handleTap = (e) => {
    if (seat.selected) return;
    const stage = e.target.getStage();
    const pointerPos = stage.getPointerPosition();
    if (seatInfo && pointerPos) {
     showTooltip(seat.seatId, pointerPos.x, pointerPos.y);
    }
  }

  const onMouseEnter = (e) => {
    const targetShape = e.target;
    const stage = targetShape.getStage();
    const container = stage.container();
    container.style.cursor = 'pointer';

    const targetAbsPos = targetShape.getAbsolutePosition();
    const shapeWidth = targetShape.width();
    const shapeAbsoluteScale = targetShape.getAbsoluteScale();
    const renderedWidth = shapeWidth * shapeAbsoluteScale.x;

    const topCenterSeatX = targetAbsPos.x + (renderedWidth / 2);
    const topCenterSeatY = targetAbsPos.y;

    clearTimeout(globalHoverTimeout);
    globalHoverTimeout = setTimeout(() => {
        showTooltip(seat.seatId, topCenterSeatX, topCenterSeatY);
    }, TOOLTIP_TIMEOUT);
  }

  const onMouseLeave = (e) => {
    // Reset cursor when not hovering
    const container = e.target.getStage().container();
    container.style.cursor = 'default';
    clearTimeout(globalHoverTimeout);
    hideTooltip();
  }

  return (
    <Rect
      x={seat.cx}
      y={seat.cy}
      id={seat.seatId}
      cornerRadius={seatBorderRadius}
      className='seat cursor-pointer'
      width={seat.w}
      height={seat.h}
      fill={seatColor}
      // Improved perf, hopefully
      transformsEnabled={"position"}
      perfectDrawEnabled={false}
      shadowForStrokeEnabled={false}
      listening={Boolean(seatInfo)}
      onClick={handleClick}
      onTap={handleTap}
      hitStrokeWidth={5}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
};

export default React.memo(Seat);
